import Header from './Header';
import { HeaderProps, HeaderValueProps } from './types';

export type { HeaderProps, HeaderValueProps };
export default Header;
